import { Node, useNode } from "@craftjs/core";
import * as React from "react";

import { ListStyles } from "./booths-list-component-styles";

type BoothsListProps = {
  id?: string;
  children: React.ReactNode;
};

const isNodeAllowed = (type) => ["BoothCard"].includes(type);

export default function BoothsList(props: BoothsListProps) {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <ListStyles id={props.id} ref={connect} data-testid="booths-list">
      {props.children}
    </ListStyles>
  );
}

BoothsList.craft = {
  custom: {
    displayName: "Booths List",
  },
  rules: {
    canMoveIn: (nodes: Node[]) => {
      const nodeTypes = nodes?.map((node) => node?.type);
      return nodeTypes.length > 0 && nodeTypes.every(isNodeAllowed);
    },
  },
};
